import { useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { Accordion, AccordionDetails, AccordionSummary, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import { ColorPicker } from 'mui-color';

import { deleteList, selectLists, updateList } from "../reducers/listSlice";
import { selectWells } from "../reducers/wellSlice";
import { ExpandMore } from "@mui/icons-material";
import { GroupWellTransferList } from "./GroupWellTransferList";
import { addProject, selectProjects } from "../reducers/projectSlice";
import { selectUser } from "../reducers/userSlice";

export const EditList = ({ projectId, listId, editListClose }) => {
  
  const lists = useSelector(selectLists);
  const list = lists.byId[listId] || {};
  const wells = useSelector(selectWells);
  const projects = useSelector(selectProjects);
  const user = useSelector(selectUser);

  const [listName, setListName] = useState(list.name || "");
  const [listDescription, setListDescription] = useState(list.description || "");
  const [listColor, setListColor] = useState(list.color || "");
  const [uwis, setUwis] = useState(list.wellUwis || []);

  const dispatch = useDispatch();

  return (
    <Dialog 
      open={true} 
      onClose={editListClose}
      fullWidth={true}
      maxWidth="md"
    >
      <DialogTitle id="form-dialog-title">Edit List</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="normal"
          id="name"
          label="List Name"
          placeholder="List Name"
          type="text"
          fullWidth
          value={listName}
          variant="outlined"
          onChange={e => setListName(e.target.value)}
        />

        <TextField
          margin="normal"
          id="description"
          label="Description"
          placeholder="Description"
          type="text"
          fullWidth
          multiline
          minRows={2}
          maxRows={5}
          value={listDescription}
          variant="outlined"
          onChange={e => setListDescription(e.target.value)}
        />

        <div style={{margin: '20px 0'}}>
          <Typography>List Color</Typography>
          <ColorPicker value={listColor} onChange={e => setListColor('#'+e.hex)}></ColorPicker>
        </div>

        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMore />}>
            <Typography>Add wells</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <GroupWellTransferList wells={lists.byId[listId].wellUwis?.map(uwi => wells.byUwi[uwi])} uwis={uwis} setUwis={setUwis} /> 
          </AccordionDetails>
        </Accordion>
      </DialogContent>
      <DialogActions style={{display: 'flex', justifyContent: 'space-between'}}>
        <Button onClick={(e) => handleDeleteList(e, listId, projectId)} color="secondary">
          Delete
        </Button>
        <div>
          <Button onClick={editListClose} color="primary" style={{marginRight: 10}}>
            Cancel
          </Button>
          <Button onClick={() => handleListSave(list, listName, listDescription, listColor, uwis)} color="primary" variant="contained">
            Save
          </Button>
        </div>  
      </DialogActions>
    </Dialog>
  );

  // FUNCTIONS

  function handleListSave(list, name, description, color, uwis) {
    const newList = {...list};
    newList.name = name;
    newList.description = description;
    newList.color = color;
    newList.wellUwis = uwis;
    dispatch(updateList({list: newList}));
    editListClose();
  };

  function handleDeleteList(e, listId, projectId) {
    e.stopPropagation();
    dispatch(deleteList({projectId: projectId, listId: listId}));

    const project = projects.byId[projectId];
    const newProject = {
      id: project?.id,
      name: project?.name, 
      color: project?.color,
      description: project?.description || "",
      createdBy: project?.createdBy,
      lastModified: new Date().toLocaleString(),
      createdOn: project?.createdOn,
      listIds: project?.listIds?.filter(id => id !== listId),
      wells: project?.wells,
      currentListId: project?.currentListId !== listId ? project?.currentListId : project?.listIds?.[0],
      economicsIds: project?.economicsIds || [],
      fbaIds: project?.fbaIds || [],
      public: project?.public || false
    };

    const newLists = newProject?.listIds?.length > 0 ? newProject?.listIds?.map(listId => {
      const currentList = lists.byId[listId];
      return {
        id: listId,
        name: currentList?.name,
        createdBy: currentList?.createdBy,
        lastModified: new Date().toLocaleString(),
        color: currentList?.color,
        description: currentList?.description || "",
        wellUwis: currentList?.wellUwis.filter(uwi => !wells.byUwi[uwi]?.local),
        typeCurveId: currentList?.typeCurveId,
        groupWellId: currentList?.groupWellId,
        forecastListTab: currentList?.forecastListTab,
        filters: currentList?.filters
      };
    }) : [];

    dispatch(addProject({ project: newProject, lists: newLists, email: user?.value?.email })).then(() => {
      console.log('Project saved successfully');
    });
    editListClose();
  };
};